import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { ActiveSign, AddNewCallDiv, AvatarDiv, CallBtn, HeadProfileBar, InfoCall, KeypadOption, RejoinCall, Sign, TeamDropDown, Title } from '../styles/dialpadstyle';
import {
  FormWrapper,
  FormColumn,
  FormGroup,
  ControlLabel,
  FormControl,
  Button
} from 'modules/theme';
import Select from 'react-select-plus';

export class EndCallProfileTheme extends Component {

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        {/* <ControlLabel required={props.required}>{label}</ControlLabel> */}
        <FormControl {...props} />
      </FormGroup>
    );
  }

  
  render() {
    const { userImg, agentName, number, onClickBtnInfo, btnInfo, onClickBtnRejoin, btnRejoin, textInfo, textRejoin, title, onChangeSelect, tagValue, optionsTag, OnClickEvent, ButtonText } = this.props;
    return (
      <span style={{display: 'block', width: '100%'}}>
        <AddNewCallDiv>
          <HeadProfileBar>
            <AvatarDiv>
              <img src={userImg} />
              <ActiveSign><Sign className="active" /></ActiveSign>
            </AvatarDiv>
            <h4>{agentName}</h4>
            <span className='number'>{number}</span>
          </HeadProfileBar>
          <CallBtn>
            <InfoCall>
              <i onClick={onClickBtnInfo}>
                <img src={btnInfo} />
              </i>
              <span>{textInfo}</span>
            </InfoCall>
            <RejoinCall>
              <i onClick={onClickBtnRejoin}>
                <img src={btnRejoin} />
              </i>
              <span>{textRejoin}</span>
            </RejoinCall>
          </CallBtn>
        </AddNewCallDiv>
        <Title>
          {title}
        </Title>
        <form>
          <TeamDropDown>
            <Select
              placeholder="Select Your Review"
              onChange={onChangeSelect}
              value={tagValue}
              options={optionsTag}
            />
          </TeamDropDown>
          <KeypadOption>
            <FormWrapper>
              {/* <FormColumn></FormColumn> */}
              <FormColumn>
                {this.renderFormGroup('', {
                  defaultValue: '',
                  placeholder: 'Type your comment...',
                  autoFocus: false,
                  required: true,
                  id: 'comment',
                  value: this.props.comment,
                  onChange: e => {
                    this.setState({ comment: e.target.value });
                  }
                })}
              </FormColumn>
            </FormWrapper>
          </KeypadOption>
          {/* <Button btnStyle="simple" size="small" onClick={OnClickEvent} block>
        {ButtonText}
      </Button> */}
          <Button
            btnStyle="default"
            type="submit"
            block
            size="xl"
          >
            {ButtonText}
          </Button>
        </form>
      </span>
    )
  }
}

EndCallProfileTheme.propTypes = {
};

EndCallProfileTheme.contextTypes = {
  __: PropTypes.func
};

export default EndCallProfileTheme


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/EndCallProfileTheme.js